var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiClient } from "@/api/ApiClient";
import "./SearchInput.css";
export const SearchInput = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);
    const handleSearch = (value) => __awaiter(void 0, void 0, void 0, function* () {
        if (value.trim() === "") {
            setSearchResults([]);
            return;
        }
        try {
            const response = yield apiClient.searchData("name", value);
            setSearchResults(response || []);
            setIsDropdownOpen(true);
        }
        catch (error) {
            console.error("Search error:", error);
            setSearchResults([]);
        }
    });
    const handleSubmit = (e) => {
        var _a;
        e.preventDefault();
        if (searchValue.trim()) {
            navigate(`/search?query=${encodeURIComponent(searchValue)}`);
            setIsDropdownOpen(false);
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }
    };
    const handleResultClick = (productId) => {
        navigate(`/product/${productId}`);
        setIsDropdownOpen(false);
        setSearchValue("");
    };
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (searchValue) {
                handleSearch(searchValue);
            }
            else {
                setSearchResults([]);
            }
        }, 300);
        return () => clearTimeout(delayDebounceFn);
    }, [searchValue]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return (_jsxs("div", { className: "search-container", ref: dropdownRef, children: [_jsx("form", { onSubmit: handleSubmit, children: _jsx("input", { ref: inputRef, type: "search", className: "search-input", placeholder: "Search for products...", value: searchValue, onChange: (e) => {
                        setSearchValue(e.target.value);
                        setIsDropdownOpen(true);
                    }, onFocus: () => searchValue && setIsDropdownOpen(true) }) }), isDropdownOpen && searchResults.length > 0 && (_jsxs("div", { className: "search-dropdown", children: [_jsx("div", { className: "search-dropdown-header", children: _jsx("span", { children: "Search results:" }) }), _jsx("ul", { className: "search-results-list", children: searchResults.map((product) => (_jsx("li", { className: "search-result-item", onClick: () => handleResultClick(product.key), children: product.name || "Unnamed product" }, product.key))) }), _jsx(Link, { to: `/search?query=${encodeURIComponent(searchValue)}`, children: _jsx("div", { className: "search-dropdown-footer", children: "View all results" }) })] }))] }));
};
